import { TABLE_IDS } from '@/legacy/constants';

type TableIdValues = (typeof TABLE_IDS)[keyof typeof TABLE_IDS];

export const CURRENT_TABLE_VERSION: Record<TableIdValues, string> = {
	[TABLE_IDS.CUSTOMER_SERVICE]: '1.0.2',
	[TABLE_IDS.FINANCE_ACTIVITY]: '1.0.0',
	[TABLE_IDS.BENEFITS]: '1.0.1',
	[TABLE_IDS.BENEFITS_ACTIVITY]: '1.0.0',
	[TABLE_IDS.POS_GENERAL]: '1.1.2',
	[TABLE_IDS.POS_PLANOGRAM]: '1.0.0',
	[TABLE_IDS.POS_DETAILS_ACTIVITY]: '1.0.0',
	[TABLE_IDS.POS_DETAILS_EVADTS]: '1.0.3',
	[TABLE_IDS.POS_PRODUCTS]: '1.0.0',
	[TABLE_IDS.POS_CONNECTIVITY]: '1.0.0',
	[TABLE_IDS.SETTINGS_DASHBOARD_CLIENTS]: '1.0.0',
	[TABLE_IDS.SETTINGS_ROLES]: '1.0.0',
	[TABLE_IDS.ALL_USERS]: '1.0.2',
	[TABLE_IDS.TAG_USERS]: '1.0.1',
	[TABLE_IDS.TAG_WHITE_LIST]: '1.0.2',
	[TABLE_IDS.POS_DEVICES]: '1.0.0',
	[TABLE_IDS.USER_ACTIVITY]: '1.0.1',
	[TABLE_IDS.NFC_TAG_USER_ACTIVITY]: '1.0.1',
	[TABLE_IDS.IRP]: '1.0.0',
	[TABLE_IDS.CONNECTIVITY]: '1.0.0',
	[TABLE_IDS.REPORTS]: '1.0.3',
	[TABLE_IDS.REPORT_TEMPLATES]: '1.0.3',
	[TABLE_IDS.CONCILIATIONS]: '1.0.0',
	[TABLE_IDS.CONCILIATIONS_DETAILS]: '1.0.0',
	[TABLE_IDS.POS_STOCK]: '1.0.0',
	[TABLE_IDS.POS_STOCK_PRODUCTS]: '1.0.0',
	[TABLE_IDS.WHITE_LISTS]: '1.0.0',
	[TABLE_IDS.QR_USERS]: '1.0.0',
	[TABLE_IDS.QR_WHITE_LIST]: '1.0.0',
	[TABLE_IDS.QR_WHITE_LISTS]: '1.0.0',
	[TABLE_IDS.QR_ACTIVITY]: '1.0.0',
	[TABLE_IDS.CONCILIATIONS_POS]: '1.0.0',
	[TABLE_IDS.CONCILIATIONS_LOCATION]: '1.0.0',
	[TABLE_IDS.CONCILIATIONS_DELEGATION]: '1.0.0',
	[TABLE_IDS.CONCILIATIONS_UNRECONCILED]: '1.0.0',
	[TABLE_IDS.RECEIVED_ALERTS]: '1.0.0',
	[TABLE_IDS.RECEIVED_ALERTS_OVERVIEW]: '1.0.0',
	[TABLE_IDS.ALERT_CONFIGURATIONS]: '1.0.1',
	[TABLE_IDS.ALERT_HISTORY]: '1.0.0',
	[TABLE_IDS.ACTIVITY_SUPPORT]: '1.0.0',
	[TABLE_IDS.POS_PERSONALIZATION_MY_DESIGNS]: '1.0.0',
	[TABLE_IDS.POS_PERSONALIZATION_DRAFTS]: '1.0.0',
	[TABLE_IDS.BENEFITS_TARGET]: '1.0.0',
	[TABLE_IDS.FAVORITE_MACHINES]: '1.0.0',
	[TABLE_IDS.POS_DELEGATION]: '1.0.0',
	[TABLE_IDS.BILLING]: '1.0.0',
};
